<template>
    <div>
        <ams-base-chart :chartType="currentChartType" :data="chartData" :showLegend="false" :customizeInnerColor="true">
            <template #title-section>
                <div class="flex justify-content-between">
                    <h5>Count of {{ label('Debriefs') }} by Learning Identified</h5>
                    <Button label="Toggle" @click="toggleLearningGraph" />
                </div>
            </template>
        </ams-base-chart>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

import { ChartTypes } from '../../../../../../enums';
import { Colors } from '../../../../../../utilities/colors';
import { useLabels } from '@/composables/LabelComposable';

const { label } = useLabels();

const props = defineProps({
    jsonData: {
        type: Array,
    },
});

const currentChartType = ref(ChartTypes.BAR);
const chartData = ref([]);

onMounted(() => {
    loadChartData();
});

const loadChartData = () => {
    chartData.value = props.jsonData
        ?.filter((item) => item.name != 'None')
        ?.map((data) => {
            return {
                label: data.name,
                values: [
                    {
                        value: data.tot,
                        bgcolor: data.name === 'Yes' ? Colors.RED : Colors.BLUE,
                    },
                ],
            };
        });
};

const toggleLearningGraph = () => {
    currentChartType.value = currentChartType.value === ChartTypes.BAR ? ChartTypes.PIE : ChartTypes.BAR;
};
</script>
